import React, { RefObject } from 'react';
import { Terminal } from '~/api/data/payment/types';
import Modal from '~/components/Modal';

type ConnectOrDisconnectModalProps = {
  showConfirmation: boolean;
  terminalModalRef: RefObject<HTMLDivElement>;
  onCancel: () => void;
  onConfirm: () => void;
  selectedTerminal?: Terminal | null;
  connectedTerminal?: Terminal | null;
};

const ConnectOrDisconnectModal = ({
  showConfirmation,
  terminalModalRef,
  onCancel,
  onConfirm,
  selectedTerminal,
  connectedTerminal,
}: ConnectOrDisconnectModalProps) => {
  const isDisconnectingOtherUser = !!selectedTerminal && selectedTerminal.id !== connectedTerminal?.id;
  const terminalName = isDisconnectingOtherUser ? selectedTerminal.name : connectedTerminal?.name;
  const cashierName = isDisconnectingOtherUser
    ? selectedTerminal.activeSession?.cashierName
    : connectedTerminal?.activeSession?.cashierName;

  const confirmLabel = isDisconnectingOtherUser ? 'Connect' : 'Disconnect';
  const title = isDisconnectingOtherUser ? `Reader already in use` : `Disconnect from Reader`;

  return (
    <Modal
      handleOnCancel={() => onCancel()}
      handleOnConfirm={() => onConfirm()}
      header={title}
      confirmlabel={confirmLabel}
      denyLabel="Cancel"
      visible={showConfirmation}
      headerIcon="warning"
      modalRef={terminalModalRef}
      className="terminal-confirmation">
      {isDisconnectingOtherUser
        ? `Connecting to “${terminalName}” will disconnect “${cashierName}”. Click “Connect” to proceed.`
        : `Are you sure you want to disconnect from “${terminalName}”?`}
    </Modal>
  );
};

export default ConnectOrDisconnectModal;
